export default __webpack_public_path__ + "static/media/handprint-18-19-page.47e53cb6.png";